import { formatResponse, get, getApiEndpoint, transformApiUrl } from '../helpers/index.js';

class KpiService {
  constructor(client) {
    this.client = client;
    this.apiEndpoint = getApiEndpoint() + 'kpi';
  }

  async weeklySale(year = 2025, initialMonth = '') {
    const action = 'ventaSemanal';
    this.apiEndpoint = transformApiUrl(this.apiEndpoint);
    const endpoint = `${this.apiEndpoint}/${action}`;
    const getResponse = await get(this.client, endpoint, {
      params: { periodo: year, mesInicial: initialMonth },
    });

    return formatResponse(getResponse);
  }

  async principalIndicator(salesPersonId = '') {
    const action = 'weekPrincipalIndicator';
    this.apiEndpoint = transformApiUrl(this.apiEndpoint);
    const endpoint = `${this.apiEndpoint}/${action}`;
    const getResponse = await get(this.client, endpoint, {
      params: { salesPersonId },
    });

    return formatResponse(getResponse);
  }

  async weeklySaleByCustomer(week='') {
    const action = 'weeklySale';
    this.apiEndpoint = transformApiUrl(this.apiEndpoint);
    const endpoint = `${this.apiEndpoint}/${action}`;
    const getResponse = await get(this.client, endpoint, {
      params: {week },
    });

    return formatResponse(getResponse);
  }

  async weeklySaleByClassTerr(week = '') {
    const action = 'salesByClassTerr';
    this.apiEndpoint = transformApiUrl(this.apiEndpoint);
    const endpoint = `${this.apiEndpoint}/${action}`;
    const getResponse = await get(this.client, endpoint, {
      params: { week },
    });
  
    return formatResponse(getResponse);
  }

  async weeklysalesByClassChan(week = '') {
    const action = 'salesByClassChan';
    this.apiEndpoint = transformApiUrl(this.apiEndpoint);
    const endpoint = `${this.apiEndpoint}/${action}`;
    const getResponse = await get(this.client, endpoint, {
      params: { week },
    });
  
    return formatResponse(getResponse);
  }
  async weeklysalesByClassSlspsn(week = '') {
    const action = 'salesByClassSlspsn';
    this.apiEndpoint = transformApiUrl(this.apiEndpoint);
    const endpoint = `${this.apiEndpoint}/${action}`;
    const getResponse = await get(this.client, endpoint, {
      params: { week },
    });
  
    return formatResponse(getResponse);
  }

  async weeklysalesBysalesByGroup(year=2025,month='03') {
    const action = 'salesByGroup';
    this.apiEndpoint = transformApiUrl(this.apiEndpoint);
    const endpoint = `${this.apiEndpoint}/${action}`;
    const getResponse = await get(this.client, endpoint, {
      params: { year, month },
    });
  
    return formatResponse(getResponse);
  }

    async weeklysalesBysalesByTypeCust(week = '', salesPersonId = '', month = '', dateStart = '', dateEnd = '') {
    const action = 'v1/salesByTypeCust';
    this.apiEndpoint = transformApiUrl(this.apiEndpoint);
    const endpoint = `${this.apiEndpoint}/${action}`;

    const getResponse = await get(this.client, endpoint, {
      params: {
        week,
        salesPersonId,
        month,
        dateStart,
        dateEnd
      }
    });
    return formatResponse(getResponse);
  }
}
export { KpiService as default };


